var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"screen"},[_c('div',{staticClass:"message"},[_vm._v("Who is experiencing this problem?")]),_vm._v(" "),_c('div',{staticClass:"tab"},[_c('div',{staticClass:"page-title"},[_vm._v(" Report A Problem ")]),_vm._v(" "),_c('hr')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5594cc86","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReportProblem.vue
// module id = null
// module chunks = 